import React from 'react';

// TODO: add document title

export default function NotFoundPage() {
  return (
    <div>
      <h1>404</h1>
      <h3>Page not found</h3>
    </div>
  );
}
